module.exports = __webpack_public_path__ + "img/sld_mfm_inv_10_t1_b1_dark.998e61f5.svg";